import angular from 'angular';
import { paymentComponents } from './components';
import { paymentServicesModule } from './services';
export const paymentModule = angular
    .module('paymentModule', [paymentComponents, paymentServicesModule])
    .name;
